import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../../firebase';

export async function callFn(name, data) {
  const res = await httpsCallable(functions, name)(data);
  return res.data;
}

// Fetches a contract PDF through the admin-only contractFile endpoint and opens it.
export async function openContractFile(contractId, kind) {
  const win = window.open('', '_blank');
  try {
    const idToken = await auth.currentUser.getIdToken();
    const res = await fetch(`/api/contracts/file?contractId=${encodeURIComponent(contractId)}&kind=${kind}`, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
    if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || 'Download failed');
    const url = URL.createObjectURL(await res.blob());
    if (win) win.location.href = url; else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (win) win.close();
    alert(e.message);
  }
}

export const STATUS_META = {
  draft:      { label: 'Draft',      color: 'var(--color-text-secondary)', bg: 'var(--color-bg-tertiary)' },
  pending:    { label: 'Pending',    color: 'var(--color-warning)',        bg: 'var(--color-warning-light)' },
  finalising: { label: 'Finalising', color: 'var(--color-info)',           bg: 'var(--color-info-light)' },
  completed:  { label: 'Completed',  color: 'var(--color-success)',        bg: 'var(--color-success-light)' },
  voided:     { label: 'Voided',     color: 'var(--color-danger)',         bg: 'var(--color-danger-light)' },
  expired:    { label: 'Expired',    color: 'var(--color-text-tertiary)',  bg: 'var(--color-bg-tertiary)' },
  waiting:    { label: 'Waiting',    color: 'var(--color-text-tertiary)',  bg: 'var(--color-bg-tertiary)' },
  invited:    { label: 'Invited',    color: 'var(--color-warning)',        bg: 'var(--color-warning-light)' },
  viewed:     { label: 'Viewed',     color: 'var(--color-info)',           bg: 'var(--color-info-light)' },
  signed:     { label: 'Signed',     color: 'var(--color-success)',        bg: 'var(--color-success-light)' },
  pay_awaiting_signature: { label: 'Not due', color: 'var(--color-text-tertiary)', bg: 'var(--color-bg-tertiary)' },
  pay_unpaid:     { label: 'Unpaid',     color: 'var(--color-warning)', bg: 'var(--color-warning-light)' },
  pay_processing: { label: 'Processing', color: 'var(--color-info)',    bg: 'var(--color-info-light)' },
  pay_active:     { label: 'Part paid',  color: 'var(--color-info)',    bg: 'var(--color-info-light)' },
  pay_paid:       { label: 'Paid',       color: 'var(--color-success)', bg: 'var(--color-success-light)' },
  pay_failed:     { label: 'Failed',     color: 'var(--color-danger)',  bg: 'var(--color-danger-light)' },
  inst_due:       { label: 'Due',        color: 'var(--color-text-tertiary)', bg: 'var(--color-bg-tertiary)' },
  inst_paid:      { label: 'Paid',       color: 'var(--color-success)', bg: 'var(--color-success-light)' },
  inst_failed:    { label: 'Failed',     color: 'var(--color-danger)',  bg: 'var(--color-danger-light)' },
};

export function StatusChip({ status }) {
  const m = STATUS_META[status] || { label: status, color: 'var(--color-text-secondary)', bg: 'var(--color-bg-tertiary)' };
  return (
    <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 'var(--radius-full)', background: m.bg, color: m.color, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>
      {m.label}
    </span>
  );
}

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');

export const inputStyle = {
  width: '100%', height: 34, padding: '0 10px', fontSize: 13,
  border: '0.5px solid var(--color-border-medium)', borderRadius: 'var(--radius-md)',
  background: 'var(--color-bg-primary)', color: 'var(--color-text-primary)', fontFamily: 'var(--font-primary)',
  boxSizing: 'border-box',
};

export const labelStyle = { fontSize: 11, color: 'var(--color-text-tertiary)', marginBottom: 5, display: 'block' };

export const fmtMoney = (minor, currency) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency.toUpperCase() }).format(minor / 100);

// Must match CONSENT_TEXT in functions/contracts.js.
export const CONSENT_TEXT = 'I agree to sign this document electronically and understand my electronic signature is legally binding.';
